import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { BusinessDivisionType, BusinessSectionType } from "~/domains";

type PropsType = {
  businessSections?: BusinessSectionType[];
  businessDivisions?: BusinessDivisionType[];
};

type ReturnType = {
  defaultDivision: BusinessDivisionType | null;
  defaultSection: BusinessSectionType | null;
};

export const useDefaultDivisionSectionFromUrl = ({
  businessSections = [],
  businessDivisions = [],
}: PropsType): ReturnType => {
  const location = useLocation();

  const businessSectionId = useMemo(() => {
    const query = new URLSearchParams(location.search);
    return query.get("business_section_id") || "";
  }, [location.search]);

  const defaultSection = useMemo(() => {
    if (!businessSectionId || businessSections.length === 0) return null;
    return (
      businessSections.find((section) => section.id === businessSectionId) ||
      null
    );
  }, [businessSectionId, businessSections]);

  const defaultDivision = useMemo(() => {
    if (!defaultSection || businessDivisions.length === 0) return null;
    return (
      businessDivisions.find(
        (division) => division.id === defaultSection.businessDivisionId,
      ) || null
    );
  }, [defaultSection, businessDivisions]);

  return { defaultDivision, defaultSection };
};
